import { Radio } from 'antd';

interface Option {
	value: string;
	label: string;
}

interface Props {
	value: string;
	options: Option[];
	onChange: (value: string) => void;
	showAllOption?: boolean;
	allOptionLabel?: string;
	/** Compact mode for tablet/horizontal layouts */
	compact?: boolean;
}

export const RadioFilter = ({
	value,
	options,
	onChange,
	showAllOption = false,
	allOptionLabel = 'All',
	compact = false,
}: Props) => {
	const handleChange = (e: any) => {
		onChange(e.target.value);
	};

	if (compact) {
		return (
			<Radio.Group
				value={value || (showAllOption ? 'all' : undefined)}
				onChange={handleChange}
				style={{
					display: 'flex',
					flexDirection: 'column',
					gap: 4,
					maxHeight: 160,
					overflowY: 'auto',
				}}
			>
				{options.map((opt) => (
					<Radio key={opt.value} value={opt.value} style={{ fontSize: 12 }}>
						{opt.label}
					</Radio>
				))}
				{showAllOption && (
					<Radio value="all" style={{ fontSize: 12, marginTop: 2, paddingTop: 4, borderTop: '1px dashed #f0f0f0' }}>
						{allOptionLabel}
					</Radio>
				)}
			</Radio.Group>
		);
	}

	return (
		<Radio.Group value={value || (showAllOption ? 'all' : undefined)} onChange={handleChange}>
			{options.map((opt) => (
				<div key={opt.value} style={{ marginBottom: 8 }}>
					<Radio value={opt.value}>{opt.label}</Radio>
				</div>
			))}
			{showAllOption && (
				<div
					style={{
						marginTop: 8,
						paddingTop: 8,
						borderTop: '1px dashed #f0f0f0',
					}}
				>
					<Radio value="all">{allOptionLabel}</Radio>
				</div>
			)}
		</Radio.Group>
	);
};